export const checkFileSize = file => {
  return file.size <= 25000000
}
